<template>
  <hm-content title="">
    <div class="application-list flex flex-wrap">
      <div class="item flex item-center" v-for="(v,i) in list" :key="i">
        <img :src="v.icon" class="img" />
        <div class="title flex-1">
          <div>{{v.title}}</div>
          <div class="subTitle">{{v.subTitle}}</div>
        </div>
        <el-button type="primary" class="btn" @click="toUrl(v.url)">进入</el-button>
      </div>
    </div>
  </hm-content>
</template>
<script>
import { mapGetters } from "vuex";
import * as XLSX from "xlsx/xlsx";
import { getCookie, setCookie } from "@/utils/utils";
import moment from "moment";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  components: {},
  data() {
    return {
      list:[
        {
          title: "促销腰带",
          subTitle: "营造大促氛围，突出促销信息",
          icon: "https://imgcdn.hemiao100.com/hemiaoBase/hmService/icon-application-01.png",
          url: "PromotionalBeltList",
        },
        {
          title: "智能活码",
          subTitle: "私域引流，智能入群神器",
          icon: "https://imgcdn.hemiao100.com/hemiaoBase/hmService/icon-application-02.png",
          url: "IntelligentCodeList",
        }
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    toUrl(name){
      this.$router.push({
        name,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.application-list {
  .item {
    width: 513px;
    height: 150px;
    background: #fff6fa;
    border-radius: 12px;
    border: 1px solid #ffd6e8;
    margin-left: 20px;
    margin-bottom: 20px;
    .img {
      width: 54px;
      height: 54px;
      margin-left: 40px;
    }
    .title {
      margin-left: 30px;
      margin-right: 30px;
      font-size: 18px;
      font-weight: bold;
      color: #222222;
      line-height: 21px;
    }
    .btn {
      margin-right: 30px;
    }
    .subTitle {
      font-size: 14px;
      font-weight: 500;
      color: #666666;
      line-height: 24px;
      margin-top: 8px;
    }
  }
}
</style>